/**
 * ⭐ POSSIBLE NO-SHOW — the board's rule (Decision 266, 2026-09-28)
 *
 * > Pete: *"Once its slot has ended"* · *"aren't these called No-Show's?"* →
 * > *"Possible no-shows (N)"; No-show is the main button*.
 *
 * ⛔ THE SAME FOUR CONDITIONS AS THE SERVER'S `POSSIBLE_NO_SHOW_WHERE`
 * (src/lib/possibleNoShowRepository.ts), so a chip flagged on the board is a row
 * in the list and the other way round:
 *   status Requested or Approved · not a door block · no arrival recorded ·
 *   the slot's end has passed.
 * ⚠️ A day-only appointment's slot is the facility's open window, so its end is
 * closing time — no special case here either.
 *
 * ⚠️ "POSSIBLE", NEVER "NO-SHOW": the data cannot tell a truck that never came
 * from one that came and was never checked in. Only a person can.
 *
 * ⭐ F180 (Decision 297, migration 235) — PLUS THE FACILITY'S NO-SHOW GRACE: the slot
 * must have ended `graceMinutes` ago (default 0 = unchanged). The server writes it as
 * `ScheduledEndUtc < now - grace`; this is the same inequality, `end + grace < now`.
 */
export interface PossibleNoShowInput {
    statusCode: string;
    direction: string;
    actualArrivalUtc: string | null;
    scheduledEndUtc: string;
}

export function isPossibleNoShow(a: PossibleNoShowInput, now: Date = new Date(), graceMinutes = 0): boolean {
    if (a.statusCode !== 'REQUESTED' && a.statusCode !== 'APPROVED') return false;
    if (a.direction === 'BLOCK') return false;
    if (a.actualArrivalUtc) return false;
    const end = Date.parse(a.scheduledEndUtc);
    if (Number.isNaN(end)) return false;
    const g = Number.isInteger(graceMinutes) && graceMinutes > 0 ? graceMinutes : 0;
    return end + g * 60_000 < now.getTime();
}
